export const IMAGE_CAROUSEL_INTERVAL_MS = 4000;

export const PHONE_NUMBER_MIN_LENGTH = 12;

export const SWAL_COLORS = {
  CONFIRM_BUTTON: '#4F46E5',
} as const;
